import { Injectable } from '@angular/core';
import { filter, firstValueFrom, fromEvent, map } from 'rxjs';
import { v4 as uuid } from 'uuid';

export type CrossWindowMessage<T = unknown> = {
  iframeId?: string;
  requestId?: string;
  data: T;
};

@Injectable({
  providedIn: 'root',
})
export class MessageWithIframeService {
  private events = fromEvent<MessageEvent>(window, 'message').pipe(
    map((e) => e.data as CrossWindowMessage),
  );

  listen<T = unknown>(iframeId: string) {
    return this.events.pipe(
      filter((res) => res.iframeId === iframeId),
      map((res) => res.data as T),
    );
  }
  request<T = unknown>(
    win: Window, // either child or parent window
    data: unknown,
    origin = '*',
  ) {
    const requestId: string = uuid();
    win.postMessage({ data, id: requestId }, origin);
    return firstValueFrom(
      this.events.pipe(
        filter((res) => res.requestId === requestId),
        map((res) => res.data as T),
      ),
    );
  }
  response(requestId: string, data: unknown) {
    const win: Window = window.opener?.parent || window.parent;
    win.postMessage({ data, id: requestId }, '*');
  }
}
